// @flow
import React from 'react';
import compose from 'lodash/fp/compose';
import injectSheet from 'react-jss';
import Dialog from '~/app/ui/Dialog';
import Button from '~/app/ui/Button';
import { S, A } from '~/app/ui/tokens';
import withPresetActions from '~/presets/composers/withPresetActions';

type Props = {
  classes: Object,
  widgetPreset: Object,
  onClose: () => void,
  addWidgetPreset: Function,
  flashMessage: Function
}

/** The last step of a new preset: its name. */
class AddPresetTitle extends React.Component {
  props: Props = this.props;

  state = {
    title: '',
    saving: false
  };

  handleAddNewPreset = () => {
    const title = this.state.title.trim();
    const { widgetPreset } = this.props;
    if (!title || this.state.saving) return;
    this.setState({ saving: true });
    this.props.addWidgetPreset({
      props: widgetPreset.props,
      widgetId: widgetPreset.widgetId,
      title
    }).then(() => {
      this.props.flashMessage(`Saved the preset “${title}”.`);
      this.props.onClose();
    }).catch((e) => {
      this.setState({ saving: false });
      this.props.flashMessage(e.message, 'ERROR');
    });
  }

  render() {
    const { classes: c, onClose } = this.props;
    const { title, saving } = this.state;

    return (
      <Dialog
        title="Name the preset"
        onClose={onClose}
        width={460}
        testId="preset-title"
        footer={(
          <>
            <Button onClick={onClose} disabled={saving}>Cancel</Button>
            <Button variant="primary" onClick={this.handleAddNewPreset} disabled={!title.trim()} busy={saving}>Save preset</Button>
          </>
        )}
      >
        <label className={c.label} htmlFor="preset-title-input">Name</label>
        <input
          id="preset-title-input"
          className={c.input}
          type="text"
          value={title}
          autoFocus
          placeholder="e.g. Robotics support · US"
          onChange={e => this.setState({ title: e.target.value })}
          onKeyDown={(e) => { if (e.key === 'Enter') this.handleAddNewPreset(); }}
        />
        <p className={c.hint}>Pick a name people will recognize in the editor’s Insert panel.</p>
      </Dialog>
    );
  }
}

const styles = {
  label: { display: 'block', marginBottom: 6, fontSize: 13, fontWeight: 600 },
  input: {
    boxSizing: 'border-box',
    width: '100%',
    height: 38,
    padding: '0 12px',
    border: `1px solid ${S.fieldLine}`,
    borderRadius: A.radius,
    fontFamily: S.ui,
    fontSize: 15,
    color: S.fg,
    '&:focus': { outline: 'none', borderColor: S.fg, boxShadow: `0 0 0 1px ${S.fg}` }
  },
  hint: { margin: '8px 0 0', fontSize: 13, color: S.muted }
};

export default compose(
  withPresetActions,
  injectSheet(styles)
)(AddPresetTitle);
